<div class="product-info-desktop-preview">
  <div class="product-details">
    <div class="program-information">
      <h3>
        @if (Episode()?.statisticsDetails) {
          {{ Episode()!.statisticsDetails!.totalLikePercentage + Episode()!.statisticsDetails!.totalLovePercentage }}٪
          پسندیدند
        } @else {
          @if (ProgramData().program.statisticsDetails) {
            {{
              ProgramData().program.statisticsDetails.totalLikePercentage +
                ProgramData().program.statisticsDetails.totalLovePercentage
            }}٪ پسندیدند
          }
        }
      </h3>
      <span class="production-year">{{ ProgramData().program.productionYear }}</span>
      <!-- <app-icon-button [IsButton]="true" Icon="subtitles" Appearance="default" [WithTooltip]="true" TooltipText="زیرنویس" /> -->
      <app-icon-button Icon="hd" Appearance="default" [WithTooltip]="true" TooltipText="کیفیت HD" [IsButton]="true" />
      <span class="production-year">{{ ProgramData().program.parentalGuidance }}</span>
    </div>
  </div>
  <div class="product-tags-info">
    @for (item of ProgramData().cast; track item) {
      @if (item?.role === "DIRECTOR") {
        <div class="product-casts">
          <span class="tag-title">{{ item?.name }}: </span>
          @for (artist of item?.artists; track artist; let j = $index) {
            <a class="tag-data-name" routerLink="/a/{{ artist?.descriptor }}">
              <span>{{ artist?.fullName }}</span>
              @if (item && item.artists && j < item.artists.length - 1) {
                <span class="item-separator">،</span>
              }
            </a>
          }
        </div>
      }
      @if (item?.role === "PERFORMER") {
        <div class="product-casts">
          <span class="tag-title">{{ item?.name }}: </span>
          @for (artist of item?.artists; track artist; let j = $index) {
            @if (j < 4) {
              <a class="tag-data-name" routerLink="/a/{{ artist?.descriptor }}">
                <span>{{ artist?.fullName }}</span>
                @if (j < 3) {
                  <span class="item-separator">،</span>
                }
              </a>
            }
          }
          <app-icon-button
            [IsButton]="true"
            class="navigate-about"
            Appearance="default"
            Icon="expand_more"
            (Click)="handleNavigateToAboutSection()"
          />
        </div>
      }
    }
    <div class="product-tags">
      <span class="tag-title">دسته‌بندی‌ها: </span>
      @for (item of ProgramData().categories; track $index) {
        <a class="tag-data-name" routerLink="/c/{{ item?.descriptor }}">
          <span>{{ item?.name }}</span>
          @if ($index < ProgramData().categories.length - 1) {
            <span class="item-separator">،</span>
          }
        </a>
      }
    </div>

    <div class="product-genres">
      @for (item of ProgramData().genres; track $index) {
        <app-tag-button Link="/g/{{ item?.descriptor }}" [Text]="item?.name!" />
      }
    </div>
  </div>
  <h1 class="product-title">
    @if (ProgramData().program.isSolitary) {
      {{ ProgramData().program.title }}
    } @else {
      @if (Episode()) {
        @if (ProgramData().seasons.length > 1) {
          {{ ProgramData().program.title }} {{ handleSeasonTitle() }} {{ Episode()!.title }}
        } @else {
          {{ ProgramData().program.title }} {{ Episode()!.title }}
        }
      } @else {
        {{ ProgramData().program.title }}
      }
    }
  </h1>
  <p class="product-summary">
    @if (Episode()) {
      {{ Episode()!.summary }}
    } @else {
      {{ ProgramData().program.summary }}
    }
  </p>
</div>
